import React, { useState } from 'react';

const industriesData = [
  { title: "Textile",  content: "We provide cutting-edge digital solutions for textile businesses, enabling automation in production, inventory tracking, and quality control. Our solutions help optimize processes from fiber to fabric.", img: "/assets/img/industries/I1.jpg" },
  { title: "Dyeing",  content: "Our software streamlines dyeing operations, ensuring precision in color matching, chemical usage optimization, and waste reduction, enhancing sustainability and compliance.", img: "/assets/img/industries/I2.jpg" },
  { title: "Weaving",  content: "We help weaving units digitize production management, track loom efficiency, and ensure seamless integration between design and manufacturing for improved productivity.",img: "/assets/img/industries/I3.jpg" },
  { title: "Processing",  content: "From pre-treatment to finishing, we offer software solutions that enhance processing efficiency, minimize defects, and optimize resource utilization.", img: "/assets/img/industries/I4.jpg" },
  { title: "Knitting",  content: "We empower knitting businesses with real-time monitoring tools, automated production planning, and quality assurance systems, ensuring smooth operations.",img: "/assets/img/industries/I5.jpg" },
  { title: "Garmenting", content: "Our ERP and automation solutions help garment manufacturers manage order processing, production scheduling, supply chain logistics, and quality control efficiently.",img: "/assets/img/industries/I6.jpg" },
  { title: "E-Commerce", content: "We develop robust e-commerce platforms with advanced features such as AI-powered recommendations, seamless payment gateways, and personalized shopping experiences to drive sales.", img: "https://images.unsplash.com/photo-1557821552-17105176677c?q=80&w=1200" },
  { title: "Manufacturing", content: "Our manufacturing solutions streamline production workflows, enhance inventory management, and integrate smart factory technologies to improve efficiency and reduce downtime.", img: "https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?q=80&w=1200" },
  { title: "Carpet", content: "We provide digital solutions for design, production tracking ,and supply chain management, helping carpet manufacturers optimize production and distribution.", img: "https://images.unsplash.com/photo-1600166898405-da9535204843?q=80&w=1200" },
  { title: "Chemical", content: "Our solutions support chemical manufacturers with compliance management, safety regulations, batch tracking, and efficient raw material utilization to ensure operational excellence.", img: "/assets/img/industries/I10.jpg" },
  { title: "Legacy App Development", content: "We help businesses transition from outdated legacy systems to modern, cloud-based, and AI-driven applications, ensuring scalability, security, and improved performance.", img: "/assets/img/industries/I11.jpeg" },
  { title: "Gen AI App Development", content: "Our expertise in GenAI helps businesses leverage AI for automation, personalized content creation, advanced analytics, and intelligent decision-making across industries.", img: "/assets/img/industries/I12.jpg" }
];

const IndustriesSection = () => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <div className="industries-section">
      <h2 className="industries-heading">Industries We Serve</h2>
      
      <div className="industries-grid">
        <div className="industries-sidebar">
          {industriesData.map((item, index) => (
            <div 
              key={index}
              onClick={() => setActiveTab(index)}
              className={`industry-tab ${activeTab === index ? 'active' : ''}`}
            >
              {item.title}
            </div>
          ))}
        </div>

        <div className="content-display">
          <div className="image-box">
            <img 
              src={industriesData[activeTab].img} 
              alt={industriesData[activeTab].title} 
              className="hero-img" 
              onError={(e) => { e.target.src = "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=1200"; }}
            />
            <div className="glass-card">
              <h3 className="card-title">{industriesData[activeTab].title}</h3>
              <p className="card-desc">{industriesData[activeTab].content}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IndustriesSection;